/** Config partagée — un seul chargement du script Maps (useJsApiLoader). */
export const GOOGLE_MAPS_LOADER_ID = 'promea-site-google-map-script';

/** Aligné sur @react-google-maps/api (defaultLibraries). */
export const GOOGLE_MAPS_LIBRARIES: ('maps')[] = ['maps'];

export const googleMapsLoaderOptions = {
  id: GOOGLE_MAPS_LOADER_ID,
  libraries: GOOGLE_MAPS_LIBRARIES,
  language: 'fr',
  region: 'FR',
} as const;
